import { useParams, Link } from "react-router-dom";
import { funds } from "../data/funds.js";
import NotFound from "./NotFound.jsx";
import RiskWarning from "../components/RiskWarning.jsx";

export default function FundDetail() {
  const { slug } = useParams();
  const fund = funds.find(f => f.slug === slug);
  if (!fund) return <NotFound />;

  return (
    <>
      <section className="page-header">
        <div className="wrap">
          <div className="eyebrow">{fund.eyebrow}</div>
          <h1>{fund.title}.</h1>
          <p className="sub">{fund.description}</p>
        </div>
      </section>

      <RiskWarning />

      <section>
        <div className="wrap" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 64 }}>
          <div>
            <div className="num">{fund.headline}</div>
            <p className="tag spacer-s">{fund.headlineSub}</p>
            <p className="sub spacer-m">{fund.description}</p>
            <Link className="btn btn-primary spacer-m" to="/data-room">Request fund documentation</Link>
          </div>
          <div>
            {fund.facts.map(([k, v]) => (
              <div className="kv" key={k}>
                <span className="k">{k}</span>
                <span className="v">{v}</span>
              </div>
            ))}
            <p className="indicative">
              Fund manager, AIFM, depositary and auditor details available in the data room.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
